export default "__VITE_ASSET__BJYTPJag__"